
export const storageFileUrl = (path) => {
  if (!path) return process.env.VUE_APP_BUCKET_URL || '';
  if (path.startsWith('http')) return path;

  const baseUrl = process.env.VUE_APP_BUCKET_URL || '';

  // Normalize: remove trailing slashes from base and leading slashes from path
  const normalizedBase = baseUrl.replace(/\/+$/, '');
  const normalizedPath = String(path).replace(/^\/+/, '');

  // If base is empty just return normalized path
  if (!normalizedBase) return `/${normalizedPath}`;

  return `${normalizedBase}/${normalizedPath}`;
}
